// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Model Management – dropdown trigger (uses labelflow-dropdown-trigger from master) */

.model-mgmt-actions .btn-group,
.model-mgmt-actions .labelflow-dropdown-trigger {
  position: relative;
  z-index: 1;
}

.model-mgmt-card__header .labelflow-dropdown-trigger {
  position: relative;
}

/* Prevent row click when clicking buttons */
.model-mgmt-actions .btn,
.model-mgmt-actions .btn-group,
.model-mgmt-actions .labelflow-dropdown-trigger {
  pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/management/modelManagement/styles/version.css"],"names":[],"mappings":"AAAA,sFAAsF;;AAEtF;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;;;EAGE,oBAAoB;AACtB","sourcesContent":["/* Model Management – dropdown trigger (uses labelflow-dropdown-trigger from master) */\n\n.model-mgmt-actions .btn-group,\n.model-mgmt-actions .labelflow-dropdown-trigger {\n  position: relative;\n  z-index: 1;\n}\n\n.model-mgmt-card__header .labelflow-dropdown-trigger {\n  position: relative;\n}\n\n/* Prevent row click when clicking buttons */\n.model-mgmt-actions .btn,\n.model-mgmt-actions .btn-group,\n.model-mgmt-actions .labelflow-dropdown-trigger {\n  pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
